export const getSettingsQuery = (
  addMarkup = false,
  objectName = 'settings',
  addGuardrail = false,
) => {
  return `
		${objectName} {
			agency_charge_rate_cents
			can_post_assignment
			can_post_job
			charge_on_call_hourly_rate_cents
			charge_on_call_hourly_rate_currency
			fee_percent
			${addMarkup ? 'location_type_markup' : ''}
			on_call_fee_percent
			payout_on_call_hourly_rate_cents
			payout_on_call_hourly_rate_currency
			ten99 {
				margin_percent_1099
				charge_rate_cents
				charge_blended_rate_cents
				modified_charge_rate_cents
				base_charge_rate_cents
				base_margin_percent
				invoicing_markup
				misc_markup
				use_blended_rate
				charge_seventh_day_rule_enabled
				payout_max_weekly_regular_hours
				payout_seventh_day_rule_enabled
				charge_max_weekly_regular_hours
				incremental_margin_percent_1099
				${
          addGuardrail
            ? `
							base_margin_percent_1099_guardrail
							payout_rate_percent_1099_guardrail
						`
            : ''
        }
				non_blended_rates {
					blended_rate_markup
					charge_max_daily_overtime_hours
					charge_max_daily_regular_hours
					charge_overtime_multiplier
					charge_double_overtime_multiplier
					payout_double_overtime_multiplier
					payout_max_daily_overtime_hours
					payout_max_daily_regular_hours
					payout_overtime_multiplier
				}
				blended_rates {
					blended_rate_markup
					charge_max_daily_overtime_hours
					charge_max_daily_regular_hours
					charge_overtime_multiplier
					charge_double_overtime_multiplier
					payout_double_overtime_multiplier
					payout_max_daily_overtime_hours
					payout_max_daily_regular_hours
					payout_overtime_multiplier
				}
			}
			w2 {
				social_security_burden_multiplier
				medicare_burden_multiplier
				federal_unemployment_percent_burden_multiplier
				state_unemployment_percent_burden_multiplier
				incremental_margin_percent_w2
				${
          addGuardrail
            ? `
							base_margin_percent_w2_guardrail
							payout_rate_percent_w2_guardrail
						`
            : ''
        }
				local {
					base_margin_percent_w2
					use_blended_rate
					charge_rate_cents
					charge_blended_rate_cents
					modified_charge_rate_cents
					base_charge_rate_cents
					invoicing_markup
					misc_markup
					operational_markup
					charge_seventh_day_rule_enabled
					payout_max_weekly_regular_hours
					payout_seventh_day_rule_enabled
					charge_max_weekly_regular_hours
					total_margin_percent_w2
					non_blended_rates {
						blended_rate_markup
						charge_max_daily_overtime_hours
						charge_max_daily_regular_hours
						charge_overtime_multiplier
						charge_double_overtime_multiplier
						payout_double_overtime_multiplier
						payout_max_daily_overtime_hours
						payout_max_daily_regular_hours
						payout_overtime_multiplier
					}
					blended_rates {
						blended_rate_markup
						charge_max_daily_overtime_hours
						charge_max_daily_regular_hours
						charge_overtime_multiplier
						charge_double_overtime_multiplier
						payout_double_overtime_multiplier
						payout_max_daily_overtime_hours
						payout_max_daily_regular_hours
						payout_overtime_multiplier
					}
				}
				travel {
					use_blended_rate
					charge_rate_cents
					charge_blended_rate_cents
					modified_charge_rate_cents
					base_charge_rate_cents
					base_margin_percent_w2_tcv
					base_margin_percent_w2_travel
					invoicing_markup
					misc_markup
					operational_markup
					assignment_bonus_tier1_travel_amount_cents
					assignment_bonus_tier1_travel_amount_tcv_cents
					assignment_bonus_tier2_travel_amount_cents
					assignment_bonus_tier2_travel_amount_tcv_cents
					margin_percent_w2_tcv
					margin_percent_w2_travel
					margin_w2_tcv_cents
					charge_seventh_day_rule_enabled
					payout_max_weekly_regular_hours
					payout_seventh_day_rule_enabled
					charge_max_weekly_regular_hours
					non_blended_rates {
						blended_rate_markup
						charge_max_daily_overtime_hours
						charge_max_daily_regular_hours
						charge_overtime_multiplier
						charge_double_overtime_multiplier
						payout_double_overtime_multiplier
						payout_max_daily_overtime_hours
						payout_max_daily_regular_hours
						payout_overtime_multiplier
					}
					blended_rates {
						blended_rate_markup
						charge_max_daily_overtime_hours
						charge_max_daily_regular_hours
						charge_overtime_multiplier
						charge_double_overtime_multiplier
						payout_double_overtime_multiplier
						payout_max_daily_overtime_hours
						payout_max_daily_regular_hours
						payout_overtime_multiplier
					}
				}
			}
			w2_fee_percent
		}`;
};
